import { Star, Quote } from "lucide-react";

export default function TestimonialCard({ testimonial }) {
  return (
    <div className="testimonial-card" data-testid={`testimonial-${testimonial.id}`}>
      {/* Quote icon */}
      <Quote className="w-8 h-8 text-sky-100 mb-4" />
      
      {/* Rating */}
      <div className="flex gap-1 mb-4">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 text-amber-400" fill="currentColor" />
        ))}
      </div>
      
      {/* Content */}
      <p className="text-slate-600 leading-relaxed mb-6 italic">
        "{testimonial.content}"
      </p>
      
      {/* Author */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center">
          <span className="text-slate-600 font-semibold text-sm">
            {testimonial.patient_name.split(' ').map(n => n[0]).join('')}
          </span>
        </div>
        <div>
          <div className="font-semibold text-slate-900">{testimonial.patient_name}</div>
          <div className="text-sm text-slate-500">{testimonial.patient_type}</div>
        </div>
      </div>
      
      {/* Service type badge */}
      {testimonial.service_type && (
        <div className="mt-4 pt-4 border-t border-slate-100">
          <span className="badge-category">{testimonial.service_type}</span>
        </div>
      )}
    </div>
  );
}
